module.exports = __webpack_public_path__ + "public/Icons/21Managenotifications.svg?9e82a4fb";